import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/spaces/$spaceId/users')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['users:manage', 'users:access-read-only'])
    ) {
      throw redirect({ params: { spaceId: params.spaceId }, to: '/settings/spaces/$spaceId' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/users/pages/users-page').then((m) => ({ default: m.default })),
  ),
});
